<template>
  <va-create-layout>
    <farms-form :title="title" :item="item"></farms-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
